module.exports = __webpack_public_path__ + "img/Czech.dcdafd5c.svg";